import * as React from 'react';

import { createIcon } from '../Icon';
export const CornerUpLeftIcon = createIcon(
  <React.Fragment>
    <polyline points="9 14 4 9 9 4" />
    <path d="M20 20v-7a4 4 0 0 0-4-4H4" />
  </React.Fragment>,
  'CornerUpLeftIcon'
);
